import React from 'react';
import { Text, Icon } from 'porosys-ui';
import Card from '../../../common/ui/components/CardLayout/CardLayout';
import handleSeprateArrayContents from '../../../common/utils/print-array-contents';
import { Link } from 'react-router-dom';
import '../styles.scss';

const PolicyCard = props => {
    const {
        isMeetingProfileToggled,
        policy,
        focusedPolicyId,
        handleToggleComments,
        handleEditPolicy,
        handleDeletePolicy,
        acl,
    } = props;

    return (
        <Card
            classes={`summary-card ${focusedPolicyId === policy._id ? 'focused' : ''}`}
            header={
                <>
                    <div className="flex">
                        <Text variant="subtitle1">
                            {isMeetingProfileToggled ? (
                                <>
                                    <Link to={`/policies/${policy._id}`}>{policy.title} </Link> | {policy.meeting.title}
                                </>
                            ) : (
                                <>
                                    {policy.title} |{' '}
                                    <Link to={`/meetings/${policy.meeting._id}`}>{policy.meeting.title} </Link>
                                </>
                            )}
                        </Text>
                    </div>
                    <div className="actions-btn">
                        <button className="btn" onClick={() => handleToggleComments(policy._id)}>
                            <Icon fontSize={1} name="comments" />
                        </button>

                        {acl && acl.delete && (
                            <button className="btn delete-button" onClick={() => handleDeletePolicy(policy._id)}>
                                <Icon fontSize={1} name="trash" />
                            </button>
                        )}
                        {acl && acl.edit && (
                            <button className="btn" onClick={() => handleEditPolicy(policy)}>
                                <Icon fontSize={1} name="pen" />{' '}
                            </button>
                        )}
                    </div>
                </>
            }
            content={
                <div>
                    <Text variant="body1" classes={{ root: 'text-muted description' }}>
                        {policy.description}
                    </Text>
                    <br />
                    <div className="participants">
                        <Text>
                            <Icon name="users" /> {handleSeprateArrayContents('fullname', policy.participants)}
                        </Text>
                    </div>
                </div>
            }
        ></Card>
    );
};

export default PolicyCard;
